import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Input, Icon, AutoComplete } from 'antd';
import classNames from 'classnames';
import styles from './index.css';
import { hasAuth } from "../../utils/NHCore";

export default class HeaderSearch extends PureComponent {
  constructor(props){
    super(props);
    this.state={
      searchMode: false,
      searchData:[]
    }
  }
  enterSearchMode = () => {
    this.setState({ searchMode: !this.state.searchMode,searchData:[] }, () => {
      if (this.state.searchMode) {
        this.input.focus();
      }
    });
  }
  leaveSearchMode = () => {
    this.setState({
      searchMode: false,
      searchData:[]
    });
  }
  openNewWin = (url)=>{
		if(url){
			const w = window.open('about:blank');
			w.location.href = url;
		}
  }
  buildOption = (searchData) => searchData.map(item=>{
    return <AutoComplete.Option key={item.wfwbz} url={item.wfwlj}>{`${item.wfwmc}(${item.wfwbz})`}</AutoComplete.Option>;
  });
  onSearch = (value)=>{
    let searchData = this.props.searchData;
    searchData = searchData.filter(item=>(item.wfwmc.indexOf(value)>-1 || item.wfwbz.indexOf(value)>-1 || item.wfwbz.indexOf(value.toUpperCase())>-1));
    this.setState({searchData});
  }
  onSelect = (value,option)=>{
    this.openNewWin(option.props.url);
  }
  render() {
    let searchData = (this.state.searchData && this.state.searchData.length>0)?this.state.searchData:this.props.searchData;
    let optionData = this.buildOption(searchData);
    return (
        <span className={styles.searchSpan}>
          {hasAuth('zhxg_yxxt_common:wfwsearch')?<Icon type="search" onClick={this.enterSearchMode}/>:undefined}
          <AutoComplete
            ref={input=>{this.input = input;}}
            className={`${styles.autoComplete} ${this.state.searchMode?styles.autoCompleteShow:undefined}`}
            style={{display:this.state.searchMode?undefined:'none'}}
            onSearch={this.onSearch}
            onSelect={this.onSelect}
            placeholder={this.props.placeholder}
          >
            {optionData}
          </AutoComplete>
        </span>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/HeaderSearch/index.js